import React, {useState, useEffect, useRef, useCallback} from 'react'
import './App.scss';
import headerLeft from './assets/header-left.png'
import headerRight from './assets/header-right.png'
import logoEtex from './assets/logo-etex.svg'
import grid from './assets/grid.png'
import SceneManager from './threejs/SceneManager'
import * as THREE from 'three'
import OrbitControls from './threejs/OrbitControls'
import GLTFLoader from './threejs/GLTFLoader'
import leftArrow from './assets/left.png'
import rightArrow from './assets/chevron-right.png'
import async from 'async'
import {RGBELoader} from './threejs/RGBELoader'
import close from './assets/close-white.svg'
import water from './assets/water.png'
import months from './assets/months.png'
import wind from './assets/wind.png'
import clou from './assets/clou.png'
import vis from './assets/vis.png'
import agrafe from './assets/agrafe.png'
import gypse from './assets/gypse.png'
import platre from './assets/platre.png'
import tape from './assets/tape.jpg'
import core from './assets/core.mp4'
import rainscreen from './assets/rainscreen.mp4'
import defentex from './assets/defentex.jpg'
import eau from './assets/eau.png'
import rigide from './assets/rigide.png'
import vapeur from './assets/vapeur.png'
import azazaz from './assets/restart.png'

const raycaster = new THREE.Raycaster();

let sceneManager
let scenes = []
let cameras = []
let animations = []
let scene
let camera
let controls
let animate
let canvas
let lastTime = null
let renderStarted = false
let req
const loader = new GLTFLoader()

function App() {
  const [presentationStarted, setPresentationStarted] = useState(false)
  const [rootFontSize, setRootFontSize] = useState(window.innerHeight)
  const [slide, setSlide] = useState(0)
  const [showArrows, setShowArrows] = useState(false)
  const [canvasVisible, setCanvasVisible] = useState(true)
  const [sceneIndex, setSceneIndex] = useState(null)
  const [indication, setIndication] = useState(null)
  const [autoplay, setAutoplay] = useState(false)

  window.addEventListener('resize', () => {
    setRootFontSize(window.innerHeight)
    if (canvasRef) {
      canvasRef.width = window.innerWidth
      canvasRef.height = window.innerHeight
      if (sceneManager) {
        sceneManager.onWindowResize(window.innerWidth, window.innerHeight)
      }
    }
  })

  const loadGLTFScene = (path, cb) => {
    loader.load(path, (gltf) => {
      let scene = new THREE.Scene()
      /*const ambientLight = new THREE.AmbientLight(0x4c4c4c)
      scene.add(ambientLight)*/
      scene.add(gltf.scene)
      animations.push(gltf.animations)
      cameras.push(gltf.cameras[0])
      scenes.push(scene)
      cb()
    })
  }

  const loadScenes = (cb) => {
    loadGLTFScene('./export_final/animation_00.glb', () => {
      loadGLTFScene('./export_final/animation_01.glb', () => {
        loadGLTFScene('./export_final/animation_06.glb', () => {
          loadGLTFScene('./export_final/animation_07.glb', () => {
            loadGLTFScene('./export_final/animation_08.glb', () => {
              loadGLTFScene('./export_final/animation_09.glb', () => {
                cb()
              })
            })
          })
        })
      })
    })
  }

  const setSceneAndCamera = (sceneIndex) => {
    sceneManager.setScene(scenes[sceneIndex])
    sceneManager.setCamera(cameras[sceneIndex])
    setSceneIndex(sceneIndex)
  }

  const playAnimation = (index, onEnded, loop, kfStart, kfEnd, reverse) => {
    console.log('playAnimation', index, onEnded ? true : false, loop, kfStart, kfEnd)
    if (kfStart === undefined) kfStart = 0
    let mixer = new THREE.AnimationMixer(sceneManager.getScene())
    let duration = 0
    for (let clip of animations[index]) {
      let action = mixer.clipAction(clip)
      action.loop = loop || THREE.LoopOnce
      if (clip.duration > duration) duration = clip.duration
      action.play()
    }
    if (kfEnd === undefined) kfEnd = duration * 24
    if (reverse) {
      let temp = kfStart
      kfStart = kfEnd
      kfEnd = temp
    }
    mixer.setTime(kfStart ? kfStart/24 - 0.001 : 0)

    animate = (delta) => {
      if (kfEnd < kfStart && (mixer.time - delta <= kfEnd/24)) {
        mixer.setTime(kfEnd / 24)
        animate = null
        if (onEnded) onEnded()
      } else if (kfStart <= kfEnd && mixer.time + delta >= (kfEnd !== undefined ? kfEnd/24 : duration)) {
        if (kfStart !== undefined && loop === THREE.LoopRepeat) {
          mixer.setTime(kfStart / 24)
        } else if (loop !== THREE.LoopRepeat) {
          mixer.setTime(kfEnd/24 - 0.001)
          animate = null
          if (onEnded) onEnded()
        }
      } else {
        mixer.update(kfEnd < kfStart ? -delta : delta)
      }
    }
  }

  const render = (time) => {
    if (controls && lastTime) { controls.update((time - lastTime) / 1000) }
    if (animate && lastTime) animate((time - lastTime) / 1000)

    lastTime = time
    sceneManager.update()
    if (renderStarted) req = requestAnimationFrame(render)
  }

  const startRender = () => {
    renderStarted = true
    render()
  }
  const stopRender = () => {
    renderStarted = false
    cancelAnimationFrame(req)
  }

  const init3D = (ref) => {
    canvas = ref
    sceneManager = SceneManager(ref)
    loadScenes(() => {
      setSceneAndCamera(0)

      canvasRef.width = window.innerWidth
      canvasRef.height = window.innerHeight
      sceneManager.onWindowResize(window.innerWidth, window.innerHeight)
      startRender()
    })
  }

  const canvasRef = useCallback(init3D, [])
  let autoplayTimeout

  const setAutoplayTimeout = (s) => {
    clearTimeout(autoplayTimeout)
    if (s === 1) {
      sceneManager.getScene().attach(sceneManager.getCamera())
      let target = sceneManager.getScene().getObjectByName("target")
      let targetPos = target.position
      controls = new OrbitControls(sceneManager.getCamera(), canvas, targetPos)
      controls.autoRotateSpeed = 0.01
      controls.autoRotate = true
      autoplayTimeout = setTimeout(goToSlide.bind(null, 2), 5000)
    } else if (s === 2) {
      controls.autoRotateSpeed = 0.003
      controls.autoRotate = true
      autoplayTimeout = setTimeout(goToSlide.bind(null, 3), 8000)
    } else if (s === 3) {
      controls.autoRotateSpeed = 0.003
      controls.autoRotate = true
      autoplayTimeout = setTimeout(goToSlide.bind(null, 4), 8000)
    } else if (s === 4) {
      autoplayTimeout = setTimeout(() => {
        setIndication('Bardage')
        autoplayTimeout = setTimeout(() => {
          setIndication('Lattes')
          autoplayTimeout = setTimeout(() => {
            setIndication('osb')
            autoplayTimeout = setTimeout(() => {
              setIndication('rainscreen')
              autoplayTimeout = setTimeout(() => {
                autoplayTimeout = setTimeout(goToSlide.bind(null, 5), 3000)
              }, 3000)
            }, 3000)
          }, 3000)
        }, 3000)
      }, 1000)
    } else if (s === 5) {
      autoplayTimeout = setTimeout(() => {
        setIndication('Bardage')
        autoplayTimeout = setTimeout(() => {
          setIndication('Lattes')
          autoplayTimeout = setTimeout(() => {
            setIndication('Defentex')
            autoplayTimeout = setTimeout(() => {
              setIndication('weatherdefence')
              autoplayTimeout = setTimeout(() => {
                autoplayTimeout = setTimeout(goToSlide.bind(null, 6), 3000)
              }, 3000)
            }, 3000)
          }, 3000)
        }, 3000)
      }, 1000)
    } else if (s === 6) {
      autoplayTimeout = setTimeout(() => {
        setIndication('platre')
        autoplayTimeout = setTimeout(() => {
          setIndication('coeur')
          autoplayTimeout = setTimeout(() => {
            goToSlide(7)
          }, 22000)
        }, 33000)
      }, 1000)
    } else if (s === 7) {
      autoplayTimeout = setTimeout(goToSlide.bind(null, 8), 3000)
    } else if (s === 8) {
      autoplayTimeout = setTimeout(goToSlide.bind(null, 9), 5000)
    } else if (s === 9) {
      autoplayTimeout = setTimeout(goToSlide.bind(null, 10), 1000)
    } else if (s === 10) {
      autoplayTimeout = setTimeout(goToSlide.bind(null, 11), 1000)
    } else if (s === 11) {
      autoplayTimeout = setTimeout(() => {
        setCanvasVisible(false)
        autoplayTimeout = setTimeout(() => {
          setSceneAndCamera(5)
          playAnimation(5, null, THREE.LoopOnce, 1, 0)
          setSceneAndCamera(4)
          playAnimation(4, null, THREE.LoopOnce, 1, 0)
          setSceneAndCamera(3)
          playAnimation(3, null, THREE.LoopOnce, 1, 0)
          setSceneAndCamera(2)
          playAnimation(2, null, THREE.LoopOnce, 1, 0)
          setSceneAndCamera(1)
          playAnimation(1, null, THREE.LoopOnce, 1, 0)

          setSlide(1)
          setCanvasVisible(true)
        }, 500)
      }, 3000)
    }
  }

  useEffect(() => {
    console.log('oooo', slide)
    if (!autoplay) {
      clearTimeout(autoplayTimeout)
      return
    }

    setAutoplayTimeout(slide)
  }, [autoplay, slide])


  const slideTransitionsForward = [
    // Slide 0
    null,

    // Slide 1
    () => {
      //stopRender()
      setPresentationStarted(true)
      setShowArrows(false)

      const animationEnded = () => {
        setSceneAndCamera(1)
        setSlide(1)
        setShowArrows(true)

        if (!autoplay) {
          sceneManager.getScene().attach(sceneManager.getCamera())
          let target = sceneManager.getScene().getObjectByName("target")
          let targetPos = target.position
          controls = new OrbitControls(sceneManager.getCamera(), canvas, targetPos)
        }
      }

      playAnimation(0, animationEnded)
    },

    // Slide 2
    (sceneManager) => {
      //stopRender()
      setShowArrows(false)

      const animationEnded = () => {
        animate = null
        setSlide(2)
        playAnimation(1, null, THREE.LoopRepeat, 80, 120)
        setShowArrows(true)
      }

      playAnimation(1, animationEnded, THREE.LoopOnce, 0, 80)
    },

    // Slide 3
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(3)
        setShowArrows(true)
      }

      playAnimation(1, animationEnded, THREE.LoopOnce, 120, 220)
    },

    // Slide 4
    () => {
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(2)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(4)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 5
    () => {
      setIndication(null)
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(5)
        setShowArrows(true)
      }

      playAnimation(2, animationEnded, THREE.LoopOnce, 0, 80)
    },

    // Slide 6
    () => {
      setIndication(null)
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(6)
        setShowArrows(true)
      }

      playAnimation(2, animationEnded, THREE.LoopOnce, 90, 180)
    },

    // Slide 7
    () => {
      setIndication(null)
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(3)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(7)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 8
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(8)
        setShowArrows(true)
        setSceneAndCamera(4)
      }

      playAnimation(3, animationEnded)
    },

    // Slide 9
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(9)
        setShowArrows(true)
      }

      playAnimation(4, animationEnded)
    },

    // Slide 10
    () => {
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(5)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(10)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 11
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(11)
        setShowArrows(true)

        sceneManager.getScene().attach(sceneManager.getCamera())
        let target = sceneManager.getScene().getObjectByName("target")
        let targetPos = target.position
        controls = new OrbitControls(sceneManager.getCamera(), canvas, targetPos)
      }

      playAnimation(5, animationEnded)
    },
  ]

  const slideTransitionsBackward = [
    null,

    // Slide 1
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(1)
        setShowArrows(true)
      }

      playAnimation(1, animationEnded, THREE.LoopOnce, 80, 0)
    },

    // Slide 2
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        playAnimation(1, null, THREE.LoopRepeat, 80, 120)
        setSlide(2)
        setShowArrows(true)
      }

      playAnimation(1, animationEnded, THREE.LoopOnce, 220, 120)
    },

    // Slide 3
    () => {
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(1)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(3)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 4
    () => {
      setIndication(null)
      setShowArrows(false)

      const animationEnded = () => {
        setSlide(4)
        setShowArrows(true)
      }

      playAnimation(2, animationEnded, undefined, 80, 0)
    },

    // Slide 5
    () => {
      setIndication(null)
      setShowArrows(false)

      const animationEnded = () => {
        setSlide(5)
        setShowArrows(true)
      }

      playAnimation(2, animationEnded, undefined, 180, 90)
    },

    // Slide 6
    () => {
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(2)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(6)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 7
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(7)
        setShowArrows(true)
      }

      setSceneAndCamera(3)
      playAnimation(3, animationEnded, undefined, undefined, undefined, true)
    },

    // Slide 8
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(8)
        setShowArrows(true)
      }

      playAnimation(4, animationEnded, undefined, undefined, undefined, true)
    },

    // Slide 9
    () => {
      setShowArrows(false)
      setCanvasVisible(false)

      setTimeout(() => {
        setSceneAndCamera(4)
        setCanvasVisible(true)

        setTimeout(() => {
          setSlide(9)
          setShowArrows(true)
        }, 500)
      }, 500)
    },

    // Slide 10
    () => {
      setShowArrows(false)

      const animationEnded = () => {
        //scene.attach(camera)
        //controls = new OrbitControls(camera, canvas, new THREE.Vector3(0,0,0))
        setSlide(10)
        setShowArrows(true)
      }

      playAnimation(5, animationEnded, undefined, undefined, undefined, true)
    },
  ]

  const startAgain = () => {
    setShowArrows(false)
    setCanvasVisible(false)

    setTimeout(() => {
      setSceneAndCamera(1)
      let mixer = new THREE.AnimationMixer(scenes[1])
      mixer.setTime(0)
      setCanvasVisible(true)

      setTimeout(() => {
        setSlide(1)
        setShowArrows(true)
      }, 500)
    }, 500)
  }

  const goToSlide = (slideIndex) => {
    console.log('goToSlide', slideIndex, slide)
    if (slideIndex > slide && slideTransitionsForward[slideIndex]) slideTransitionsForward[slideIndex](sceneManager)
    else if (slideIndex < slide && slideTransitionsBackward[slideIndex]) slideTransitionsBackward[slideIndex](sceneManager)
    else if (slide !== slideIndex) {
      setSlide(slideIndex)
    }
  }

  const getScreenCoords = (pos) => {
    pos.project(cameras[sceneIndex])
    pos.x = ((pos.x + 1) / 2 * 100).toString() + '%'
    pos.y = - ((pos.y - 1) / 2 * 100).toString() + '%'

    return {left: pos.x, top: pos.y}
  }

  const onMouseClick = (x, y) => {
    if (sceneIndex === null) return

    let mousePosition = new THREE.Vector2()
    mousePosition.x = x / window.innerWidth * 2 - 1;
    mousePosition.y = - y / (window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(mousePosition, cameras[sceneIndex])
    if (scenes[sceneIndex].children) {
      let intersects = raycaster.intersectObjects(scenes[sceneIndex].children, true).filter(result => result.object.type === 'Mesh')
      if (intersects.length > 0) {
        console.log(intersects[0].point, intersects[0].object.name, intersects[0].object)
      }
    }
  }

  const restart = () => {
    window.location.reload()
  }

  const indicationText = {
    'Bardage': 'Timber frames',
    'Lattes': 'External ventilated cladding',
    'Defentex': 'Defentex',
    'rainscreen': "Rainscreen",
    'osb': 'OSB panel',
    'weatherdefence': "Weather Defence tape",
    'coeur': 'Specifically developped facer',
    'platre': 'Hydrofugated and high-density core'
  }

  let platreVideo = useRef(null)
  let coeurVideo = useRef(null)

  useEffect(() => {
    if (indication === 'platre') {
      coeurVideo.current.oncanplay = () => {
        coeurVideo.current.play()
      }
      coeurVideo.current.load()
    } else if (indication === 'coeur') {
      platreVideo.current.oncanplay = () => {
        platreVideo.current.play()
      }
      platreVideo.current.load()
    }
  }, [indication])

  return (
    <div className="App" style={{fontSize: rootFontSize}}>
      <canvas style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: (canvasVisible ? 1 : 0)}} ref={canvasRef} onClick={e => { onMouseClick(e.clientX, e.clientY) }} />

      <img src={grid} className='gridTopLeft' />
      <img src={headerLeft} className='headerLeft' />
      <img src={headerRight} className='headerRight' />
      <img src={logoEtex} className='logoEtex' onClick={restart} style={{pointerEvents: (slide === 0 ? undefined : 'auto'), cursor: 'pointer'}} />

      <div className={'logoSiniat' + (presentationStarted ? ' hidden' : '')}>
        <img src={logoEtex} />
        <div className='defentexName'>Defentex</div>
        {
          sceneIndex !== null
          ? (
            <>
              <div className='button' onClick={() => { goToSlide(1) }}>Start presentation</div>
              <div onClick={() => {setAutoplay(!autoplay)}} style={{pointerEvents: 'auto', display: 'flex', zIndex: 100, flexDirection: 'row', alignItems: 'center', cursor: 'pointer', position: 'absolute', left: '20%', top: '50%'}}>
                <div className={'checkbox' + (autoplay ? ' selected' : '')}>
                  <div className='checkmark' />
                </div>
                <div style={{fontSize: '2%'}}>Autoplay</div>
              </div>
            </>

          )

          : <div className='loading'>Loading...</div>
        }

      </div>
      <div className={'leftArrow' + ((!autoplay && showArrows && slide > 1) ? '' : ' hidden')} onClick={() => { goToSlide(slide - 1) }}>
        <img src={leftArrow} onClick={() => { goToSlide(slide - 1) }} />
        <div>PREV</div>
      </div>

      <div className={'rightArrow' + ((!autoplay && showArrows && slide < 11) ? '' : ' hidden')} onClick={() => { goToSlide(slide + 1) }}>
        <div>NEXT</div>
        <img src={rightArrow} />
      </div>

      <div className={'rightArrow'+ ((!autoplay && showArrows && slide === 11) ? '' : ' hidden')} onClick={restart}>
        <div>RESTART</div>
        <img src={azazaz} style={{padding: '10px'}}/>
      </div>

      <div className='borderBottom' />
      <div className={'message' + ((!autoplay && showArrows && (slide >= 1 && slide <= 3 || slide === 11)) ? '' : ' hidden')}>Use the mouse to turn around the 3D model.</div>
      {
        slide > 0 && <div style={{pointerEvents: 'auto', position: 'absolute', top: '10px', left: '10px', fontSize: '1.5%', cursor: 'pointer', color: 'white', textDecoration: 'underline'}} onClick={restart}>Close</div>
      }

      {
        (slide === 2 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%'}}>
              <div className='details'>Building without structural racking board under wind pressure.</div>
            </div>
          </>
        )
      }

      {
        (slide === 3 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%'}}>
              <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                <div className='icons'>
                  <img src={wind} />
                </div>
              </div>
              <div className='details'>Structural reinforcement thanks to Defentex. The only product suitable for service Class 3 according to Eurocode 5.</div>
            </div>
          </>
        )
      }

      {
        (slide === 4 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%'}}>
              <div className='details'>Traditional timber frame construction</div>
            </div>
          </>
        )
      }
      {
        (slide === 4 && showArrows) && (
          <>
            <div className={'handle' + (indication === 'Lattes' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(3.794, 0.366, 0.503))} onClick={() => { setIndication('Lattes') }} />
            <div className={'handle' + (indication === 'osb' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(1.469, 1.536, -0.628))} onClick={() => { setIndication('osb') }} />
            <div className={'handle' + (indication === 'rainscreen' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(2.07, 1.89, -0.32))} onClick={() => { setIndication('rainscreen') }} />
            <div className={'handle' + (indication === 'Bardage' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(0.96, 1.06, -0.767))} onClick={() => { setIndication('Bardage') }} />
          </>
        )
      }

      {
        (slide === 5 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%'}}>
              <div className='details'><b>Unique solution for Class 3 according to Eurocode 5</b></div>
              <div className='details'>Designed specifically as a shear racking panel for timber frame buildings, <b>DEFENTEX SE12,5</b> is the first panel that has been granted with an ETA and can be used in service class 3 with no rainproof membrane, offering an economical technical solution that is quick and easy to apply.</div>
            </div>
          </>
        )
      }
      {
        (slide === 5 && showArrows) && (
          <>
            <div className={'handle' + (indication === 'Lattes' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(3.794, 0.366, 0.503))} onClick={() => { setIndication('Lattes') }} />

            <div className='caption' style={{position: 'absolute', opacity: (indication === 'Defentex' ? 1 : 0), ...getScreenCoords(new THREE.Vector3(1.563, 1.568, -0.58))}}>
              <div className='line tape'>
                <div className='img'><img src={defentex} /></div>
              </div>
            </div>
            <div className={'handle' + (indication === 'Defentex' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(1.563, 1.568, -0.58))} onClick={() => { setIndication('Defentex') }} />

            <div className={'handle' + (indication === 'Bardage' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(0.96, 1.06, -0.767))} onClick={() => { setIndication('Bardage') }} />

            <div className='caption' style={{position: 'absolute', opacity: (indication === 'weatherdefence' ? 1 : 0), ...getScreenCoords(new THREE.Vector3(3.368, 2.198, 0.341))}}>
              <div className='line tape'>
                <div className='img'><img src={tape} /></div>
              </div>
            </div>
            <div className={'handle' + (indication === 'weatherdefence' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(3.368, 2.198, 0.341))} onClick={() => { setIndication('weatherdefence') }} />
          </>
        )
      }

      {
        (slide === 6 && showArrows) && (
          <>
            <div className='caption' style={{position: 'absolute', opacity: (indication === 'coeur' ? 1 : 0), ...getScreenCoords(new THREE.Vector3(1.684, 1.646, -0.518))}}>
              <div className='line platre2'>
                <div className='img'><video ref={platreVideo} src={rainscreen} loop muted /></div>
              </div>
            </div>
            <div className={'handle' + (indication === 'coeur' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(1.684, 1.646, -0.518))} onClick={() => { setIndication('coeur') }} />

            <div style={{position: 'absolute', opacity: (indication === 'platre' ? 1 : 0), ...getScreenCoords(new THREE.Vector3(1.594, 1.997, -0.558))}}>
              <div className='line coeur'>
                <div className='img'><video ref={coeurVideo} src={core} loop muted /></div>
              </div>
            </div>
            <div className={'handle' + (indication === 'platre' ? ' selected' : '')} style={getScreenCoords(new THREE.Vector3(1.594, 1.997, -0.558))} onClick={() => { setIndication('platre') }} />

            <div className='panel' style={{width: '35%', left: '7.5%', boxShadow: 'none', borderBottom: 'none', backgroundColor: undefined}}>
              <div style={{marginTop: '5%', width: '100%', bottom: undefined, position: 'static'}} className='panel'>
                <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                  <div className='icons'>
                    <img src={rigide} className='icon mini' />
                  </div>
                </div>
                <div className='details'><b>STRUCTURAL RACKING BOARD</b></div>
                <div className='details mini'>Its exclusive high-density technology (High-density core technology = HDC core) makes <b>DEFENTEX</b> the first panel suitable for <b>service class 3, validated by ETA no. 19-0690</b>.</div>
                <div className='details mini'><b>DEFENTEX</b> is generally fastened with nails or staples.</div>
                <div className='details mini'><b>DEFENTEX</b> is included in the ACORD-Bot building specification software from itech.</div>
              </div>
              <div style={{marginTop: '5%', width: '100%', bottom: undefined, position: 'static'}} className='panel'>
                <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                  <div className='icons'>
                    <img src={eau} className='icon mini' />
                  </div>
                </div>
                <div className='details'><b>RIGID RAINPROOF MEMBRANE</b></div>
                <div className='details mini'>Combined with the WEATHER DEFENCE adhesive tape, <b>DEFENTEX</b> guarantees the wall sealing for three months before a finish coat is applied (contact us). <b>DEFENTEX is highly impact-resistant</b>, an advantage during transport and application on site.</div>
              </div>
              <div style={{marginTop: '5%', width: '100%', bottom: undefined, position: 'static'}} className='panel'>
                <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                  <div className='icons'>
                    <img src={vapeur} className='icon mini' />
                  </div>
                </div>
                <div className='details'><b>VAPOUR PERMEABILITY</b></div>
                <div className='details mini'>Due to its composition, <b>DEFENTEX</b> has a low resistance to water vapour diffusion : Sd = 0.13 m.</div>
                <div className='details mini'>Thanks to an industrial process that guarantees very low scatter in Sd values, <b>DEFENTEX</b> is particularly <b>suited to exterior racking on breathable walls</b>.</div>
              </div>

            </div>
          </>
        )
      }

      {
        (slide === 7 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%', bottom: '12.3%'}}>
              <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                <div className='icons'>
                  <img src={clou} />
                  <img src={agrafe} />
                </div>
              </div>
              <div className='details'>For racking applications, the board shall be fixed with staples or nails.</div>
            </div>
          </>
        )
      }

      {
        (slide === 8 && showArrows) && (
          <>
            <div className='panel' style={{right: '1.27%', bottom: '12.3%'}}>
              <div style={{flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                <div className='icons'>
                  <img src={water} />
                  <img src={wind} />
                  <img src={months} />
                </div>
                {/*<div className='closeButton'>
                  <div>FERMER</div>
                  <img src={close} />
                </div>*/}
              </div>
              <div className='details'>The guaranteed exposure period during the jobsite phase is 3 months.</div>
            </div>
          </>
        )
      }

      {
        (indication && showArrows) && (
          <div className='indication'>
            <div className='diagonal' />
            <div className='text'>{indicationText[indication]}</div>
          </div>
        )
      }
    </div>
  );
}

export default App;
